export default __webpack_public_path__ + "static/media/kangcuci-logo.bcf4f669.png";